import { z } from "zod";

const BaseSearchItemSchema = z.object({
  id: z.number().or(z.string()),
  title: z.string(),
  description: z.string().optional(),
  subDescription: z.string().optional()
});

const WorkflowSearchItemSchema = BaseSearchItemSchema.extend({
  type: z.literal("workflow"),
  logo: z.string().url().optional()
});

const FileSearchItemSchema = BaseSearchItemSchema.extend({
  type: z.literal("file"),
  workflowId: z.number(),
  stepId: z.number()
});

const FieldSearchItemSchema = BaseSearchItemSchema.extend({
  type: z.literal("field"),
  workflowId: z.number(),
  stepId: z.number(),
  fieldValue: z.string()
});

const ObjectSearchItemSchema = BaseSearchItemSchema.extend({
  type: z.literal("object"),
  description: z.string(),
  objectType: z.string(),
  objectId: z.string()
});

const SearchItemSchema = z.discriminatedUnion("type", [
  WorkflowSearchItemSchema,
  FileSearchItemSchema,
  FieldSearchItemSchema,
  ObjectSearchItemSchema
]);

export type SearchItem = z.infer<typeof SearchItemSchema>;

export const RecentSearchesSchema = z.record(z.array(SearchItemSchema));
